// AUTO-GENERATED — do not edit. Re-generated on each server startup.
// Source: mediaRegistry from system_data.json (S3)  |  Generated: 2026-09-22T17:31:33.943Z

// Full array — all active media objects
export const assetsData = [
  {
    "id": "media-1790098269832-0",
    "image": "/media/maestroshield-whitelable/gallery/1790098269832-0.png",
    "name": "maestroshield_florida.png",
    "status": true,
    "uploadedAt": "2026-09-22T17:31:15.693Z"
  },
  {
    "id": "media-1790097765952-0",
    "image": "/media/maestroshield-whitelable/gallery/1790097765952-0.png",
    "name": "verified-vector-icon-account-verification-verification-icon_564974-1246 Background Removed.png",
    "status": true,
    "uploadedAt": "2026-09-22T17:22:50.015Z"
  },
  {
    "id": "media-1789561416587-0",
    "image": "/media/maestroshield-whitelable/gallery/1789561416587-0.jpg",
    "name": "suntex-80-stucco.jpg",
    "status": true,
    "uploadedAt": "2026-09-16T12:23:37.458Z"
  },
  {
    "id": "media-1789561416587-1",
    "image": "/media/maestroshield-whitelable/gallery/1789561416587-1.jpg",
    "name": "suntex-80-grey.jpg",
    "status": true,
    "uploadedAt": "2026-09-16T12:23:37.431Z"
  },
  {
    "id": "media-1789561416587-2",
    "image": "/media/maestroshield-whitelable/gallery/1789561416587-2.jpg",
    "name": "suntex-80-dark-bronze.jpg",
    "status": true,
    "uploadedAt": "2026-09-16T12:23:37.294Z"
  },
  {
    "id": "media-1789561416587-3",
    "image": "/media/maestroshield-whitelable/gallery/1789561416587-3.jpg",
    "name": "suntex-80-brown.jpg",
    "status": true,
    "uploadedAt": "2026-09-16T12:23:37.345Z"
  },
  {
    "id": "media-1789561416587-4",
    "image": "/media/maestroshield-whitelable/gallery/1789561416587-4.jpg",
    "name": "suntex-80-black.jpg",
    "status": true,
    "uploadedAt": "2026-09-16T12:23:37.345Z"
  },
  {
    "id": "media-1789561416587-5",
    "image": "/media/maestroshield-whitelable/gallery/1789561416587-5.jpg",
    "name": "suntex-80-beige.jpg",
    "status": true,
    "uploadedAt": "2026-09-16T12:23:37.448Z"
  },
  {
    "id": "media-1789559480493-0",
    "image": "/media/maestroshield-whitelable/gallery/1789559480493-0.mp4",
    "name": "maestroshield_retractable_screens_video.mp4",
    "status": true,
    "uploadedAt": "2026-09-16T11:51:27.148Z"
  },
  {
    "id": "media-1789558375858-0",
    "image": "/media/maestroshield-whitelable/gallery/1789558375858-0.png",
    "name": "maestroshield_outdoor_contact_us_image.png",
    "status": true,
    "uploadedAt": "2026-09-16T11:32:57.770Z"
  },
  {
    "id": "media-1789556590492-0",
    "image": "/media/maestroshield-whitelable/gallery/1789556590492-0.png",
    "name": "maestro_sheild_review_1.png",
    "status": true,
    "uploadedAt": "2026-09-16T11:03:11.014Z"
  },
  {
    "id": "media-1789556590492-1",
    "image": "/media/maestroshield-whitelable/gallery/1789556590492-1.png",
    "name": "maestro_sheild_review_2.png",
    "status": true,
    "uploadedAt": "2026-09-16T11:03:11.049Z"
  },
  {
    "id": "media-1789556590492-2",
    "image": "/media/maestroshield-whitelable/gallery/1789556590492-2.png",
    "name": "maestro_sheild_review_3.png",
    "status": true,
    "uploadedAt": "2026-09-16T11:03:11.046Z"
  },
  {
    "id": "media-1789556590492-3",
    "image": "/media/maestroshield-whitelable/gallery/1789556590492-3.png",
    "name": "maestro_sheild_review_4.png",
    "status": true,
    "uploadedAt": "2026-09-16T11:03:11.048Z"
  },
  {
    "id": "media-1789556590492-4",
    "image": "/media/maestroshield-whitelable/gallery/1789556590492-4.png",
    "name": "maestro_sheild_review_5.png",
    "status": true,
    "uploadedAt": "2026-09-16T11:03:11.048Z"
  },
  {
    "id": "media-1789408919616-0",
    "image": "/media/maestroshield-whitelable/gallery/1789408919616-0.png",
    "name": "MaestroShield_Dealer_Portal_Login_App_Screen.png",
    "status": true,
    "uploadedAt": "2026-09-14T18:02:01.316Z"
  },
  {
    "id": "media-1789407680992-0",
    "image": "/media/maestroshield-whitelable/gallery/1789407680992-0.png",
    "name": "MaestroShield_Dealer_Portal_App_Promo Background Removed.png",
    "status": true,
    "uploadedAt": "2026-09-14T17:41:22.965Z"
  },
  {
    "id": "media-1789407134146-0",
    "image": "/media/maestroshield-whitelable/gallery/1789407134146-0.svg",
    "name": "Golden_Yellow_Blob_Shape_Graphic.svg",
    "status": true,
    "uploadedAt": "2026-09-14T17:32:14.710Z"
  },
  {
    "id": "media-1789407134146-1",
    "image": "/media/maestroshield-whitelable/gallery/1789407134146-1.png",
    "name": "Yellow_Organic_Blob_Shape.png",
    "status": true,
    "uploadedAt": "2026-09-14T17:32:14.842Z"
  },
  {
    "id": "media-1789401398443-0",
    "image": "/media/maestroshield-whitelable/gallery/1789401398443-0.png",
    "name": "MaestroShield_Retractable_Screen_Fabric_Samples.png",
    "status": true,
    "uploadedAt": "2026-09-14T15:56:39.836Z"
  },
  {
    "id": "media-1789401398443-1",
    "image": "/media/maestroshield-whitelable/gallery/1789401398443-1.png",
    "name": "Sunset_Ocean_View_Covered_Patio_Sectional_Sofa.png",
    "status": true,
    "uploadedAt": "2026-09-14T15:56:39.817Z"
  },
  {
    "id": "media-1789401398443-2",
    "image": "/media/maestroshield-whitelable/gallery/1789401398443-2.png",
    "name": "Makita_Drill_Window_Frame_Metal_Installation.png",
    "status": true,
    "uploadedAt": "2026-09-14T15:56:39.861Z"
  },
  {
    "id": "media-1789401398443-3",
    "image": "/media/maestroshield-whitelable/gallery/1789401398443-3.png",
    "name": "Window_Frame_Width_Measurement_Tape.png",
    "status": true,
    "uploadedAt": "2026-09-14T15:56:39.885Z"
  },
  {
    "id": "media-1789398980630-0",
    "image": "/media/maestroshield-whitelable/gallery/1789398980630-0.png",
    "name": "rolldown_shutter.png",
    "status": true,
    "uploadedAt": "2026-09-14T15:16:22.401Z"
  },
  {
    "id": "media-1789389598551-0",
    "image": "/media/maestroshield-whitelable/gallery/1789389598551-0.png",
    "name": "Window_Blinds_Shutters_Feature_Icons_Set.png",
    "status": true,
    "uploadedAt": "2026-09-14T12:39:59.574Z"
  },
  {
    "id": "media-1789389598551-1",
    "image": "/media/maestroshield-whitelable/gallery/1789389598551-1.png",
    "name": "Wind_Weather_Icon_Circle.png",
    "status": true,
    "uploadedAt": "2026-09-14T12:39:59.433Z"
  },
  {
    "id": "media-1789389598551-2",
    "image": "/media/maestroshield-whitelable/gallery/1789389598551-2.png",
    "name": "Sun_Icon_Navy_Circle.png",
    "status": true,
    "uploadedAt": "2026-09-14T12:39:59.476Z"
  },
  {
    "id": "media-1789389598551-3",
    "image": "/media/maestroshield-whitelable/gallery/1789389598551-3.png",
    "name": "Solar_Panel_Collector_Icon.png",
    "status": true,
    "uploadedAt": "2026-09-14T12:39:59.609Z"
  },
  {
    "id": "media-1789389598551-4",
    "image": "/media/maestroshield-whitelable/gallery/1789389598551-4.png",
    "name": "Rolling_Shutter_Door_Icon.png",
    "status": true,
    "uploadedAt": "2026-09-14T12:39:59.469Z"
  },
  {
    "id": "media-1789389598551-5",
    "image": "/media/maestroshield-whitelable/gallery/1789389598551-5.png",
    "name": "Presentation_Screen_Icon_Navy.png",
    "status": true,
    "uploadedAt": "2026-09-14T12:39:59.437Z"
  },
  {
    "id": "media-1789389598551-6",
    "image": "/media/maestroshield-whitelable/gallery/1789389598551-6.png",
    "name": "Bug_Insect_Icon_Navy_Circle.png",
    "status": true,
    "uploadedAt": "2026-09-14T12:39:59.582Z"
  },
  {
    "id": "media-1789389598551-7",
    "image": "/media/maestroshield-whitelable/gallery/1789389598551-7.png",
    "name": "Adjustable_Height_Table_Icon.png",
    "status": true,
    "uploadedAt": "2026-09-14T12:39:59.470Z"
  },
  {
    "id": "media-1788955445395-0",
    "image": "/media/maestroshield-whitelable/gallery/1788955445395-0.png",
    "name": "Maestroshield_Retractable_Screens_Ad_Patios_Balconies Background Removed.png",
    "status": true,
    "uploadedAt": "2026-09-09T12:04:07.069Z"
  },
  {
    "id": "media-1788954937970-0",
    "image": "/media/maestroshield-whitelable/gallery/1788954937970-0.png",
    "name": "Retractable_Screens_Mobile_App_Ad_0549764489.png",
    "status": true,
    "uploadedAt": "2026-09-09T11:55:39.771Z"
  },
  {
    "id": "media-1788949657523-0",
    "image": "/media/maestroshield-whitelable/gallery/1788949657523-0.png",
    "name": "Black_White_Diagonal_Light_Beam_Abstract_mask.png",
    "status": true,
    "uploadedAt": "2026-09-09T10:27:39.180Z"
  },
  {
    "id": "media-1788901859998-0",
    "image": "/media/maestroshield-whitelable/gallery/1788901859998-0.webp",
    "name": "Outdoor_Pergola_Enclosure_With_Roller_Blinds_Dark_Frame.webp",
    "status": true,
    "uploadedAt": "2026-09-08T21:11:00.735Z"
  },
  {
    "id": "media-1788901803128-0",
    "image": "/media/maestroshield-whitelable/gallery/1788901803128-0.png",
    "name": "White_Three_Story_Coastal_Commercial_Building_Exterior.png",
    "status": true,
    "uploadedAt": "2026-09-08T21:10:04.776Z"
  },
  {
    "id": "media-1788901803128-1",
    "image": "/media/maestroshield-whitelable/gallery/1788901803128-1.webp",
    "name": "Modern_White_Screened_Patio_Enclosure_Exterior.webp",
    "status": true,
    "uploadedAt": "2026-09-08T21:10:03.867Z"
  },
  {
    "id": "media-1788901374814-0",
    "image": "/media/maestroshield-whitelable/gallery/1788901374814-0.jpeg",
    "name": "Florida_Waterfront_Modern_Pergola_With_Louvered_Roof.jpeg",
    "status": true,
    "uploadedAt": "2026-09-08T21:02:56.338Z"
  },
  {
    "id": "media-1788901326476-0",
    "image": "/media/maestroshield-whitelable/gallery/1788901326476-0.webp",
    "name": "Pool_Patio_Motorized_Screen_Shades_Exterior.webp",
    "status": true,
    "uploadedAt": "2026-09-08T21:02:07.902Z"
  },
  {
    "id": "media-1788901260340-0",
    "image": "/media/maestroshield-whitelable/gallery/1788901260340-0.webp",
    "name": "Rooftop_Bar_Patio_Wood_Ceiling_Ceiling_Fans_Balcony_View.webp",
    "status": true,
    "uploadedAt": "2026-09-08T21:01:02.371Z"
  },
  {
    "id": "media-1788901260340-1",
    "image": "/media/maestroshield-whitelable/gallery/1788901260340-1.webp",
    "name": "Restaurant_Patio_Green_Railing_Outdoor_Dining_Street_View.webp",
    "status": true,
    "uploadedAt": "2026-09-08T21:01:01.792Z"
  },
  {
    "id": "media-1788901260340-2",
    "image": "/media/maestroshield-whitelable/gallery/1788901260340-2.webp",
    "name": "Pool_Patio_Motorized_Screen_Shades_Exterior.webp",
    "status": true,
    "uploadedAt": "2026-09-08T21:01:01.723Z"
  },
  {
    "id": "media-1788901260340-3",
    "image": "/media/maestroshield-whitelable/gallery/1788901260340-3.webp",
    "name": "Sirocco_Mediterranean_Restaurant_Outdoor_Patio_Screens.webp",
    "status": true,
    "uploadedAt": "2026-09-08T21:01:01.302Z"
  },
  {
    "id": "media-1788901260340-4",
    "image": "/media/maestroshield-whitelable/gallery/1788901260340-4.webp",
    "name": "Airstream_Carport_Stone_Column_Motorized_Screens.webp",
    "status": true,
    "uploadedAt": "2026-09-08T21:01:01.280Z"
  },
  {
    "id": "media-1788884205543-0",
    "image": "/media/maestroshield-whitelable/gallery/1788884205543-0.mp4",
    "name": "2023-09-27_Lakehouse_Screen_Door_Opening_Video.mp4",
    "status": true,
    "uploadedAt": "2026-09-08T16:16:59.917Z"
  },
  {
    "id": "media-1788883453710-0",
    "image": "/media/maestroshield-whitelable/gallery/1788883453710-0.jpg",
    "name": "MaestroShield_Building_Exterior_Sign.jpg",
    "status": true,
    "uploadedAt": "2026-09-08T16:04:16.932Z"
  },
  {
    "id": "media-1788883449472-0",
    "image": "/media/maestroshield-whitelable/gallery/1788883449472-0.png",
    "name": "Waterfront_Modern_Home_Pool_Palm_Trees_Florida.png",
    "status": true,
    "uploadedAt": "2026-09-08T16:04:11.562Z"
  },
  {
    "id": "media-1788881930765-0",
    "image": "/media/maestroshield-whitelable/gallery/1788881930765-0.png",
    "name": "Luxury_Waterfront_Home_Pool_Palm_Trees_Florida.png",
    "status": true,
    "uploadedAt": "2026-09-08T15:38:52.484Z"
  },
  {
    "id": "media-1788881556813-0",
    "image": "/media/maestroshield-whitelable/gallery/1788881556813-0.png",
    "name": "maestro_sheield_logo.png",
    "status": true,
    "uploadedAt": "2026-09-08T15:32:37.388Z"
  },
  {
    "id": "",
    "image": "",
    "name": "",
    "status": true,
    "uploadedAt": ""
  }
];

// Keyed by filename for direct code access
// e.g.  import { ASSETS } from '../Public/assets-data';
//       const logo = ASSETS.FLOWMA_FULL_BLACK_1;
export const ASSETS = {
  "MAESTROSHIELD_FLORIDA": "/media/maestroshield-whitelable/gallery/1790098269832-0.png",
  "VERIFIED_VECTOR_ICON_ACCOUNT_VERIFICATION_VERIFICATION_ICON_564974_1246_BACKGROUND_REMOVED": "/media/maestroshield-whitelable/gallery/1790097765952-0.png",
  "SUNTEX_80_STUCCO": "/media/maestroshield-whitelable/gallery/1789561416587-0.jpg",
  "SUNTEX_80_GREY": "/media/maestroshield-whitelable/gallery/1789561416587-1.jpg",
  "SUNTEX_80_DARK_BRONZE": "/media/maestroshield-whitelable/gallery/1789561416587-2.jpg",
  "SUNTEX_80_BROWN": "/media/maestroshield-whitelable/gallery/1789561416587-3.jpg",
  "SUNTEX_80_BLACK": "/media/maestroshield-whitelable/gallery/1789561416587-4.jpg",
  "SUNTEX_80_BEIGE": "/media/maestroshield-whitelable/gallery/1789561416587-5.jpg",
  "MAESTROSHIELD_RETRACTABLE_SCREENS_VIDEO": "/media/maestroshield-whitelable/gallery/1789559480493-0.mp4",
  "MAESTROSHIELD_OUTDOOR_CONTACT_US_IMAGE": "/media/maestroshield-whitelable/gallery/1789558375858-0.png",
  "MAESTRO_SHEILD_REVIEW_1": "/media/maestroshield-whitelable/gallery/1789556590492-0.png",
  "MAESTRO_SHEILD_REVIEW_2": "/media/maestroshield-whitelable/gallery/1789556590492-1.png",
  "MAESTRO_SHEILD_REVIEW_3": "/media/maestroshield-whitelable/gallery/1789556590492-2.png",
  "MAESTRO_SHEILD_REVIEW_4": "/media/maestroshield-whitelable/gallery/1789556590492-3.png",
  "MAESTRO_SHEILD_REVIEW_5": "/media/maestroshield-whitelable/gallery/1789556590492-4.png",
  "MAESTROSHIELD_DEALER_PORTAL_LOGIN_APP_SCREEN": "/media/maestroshield-whitelable/gallery/1789408919616-0.png",
  "MAESTROSHIELD_DEALER_PORTAL_APP_PROMO_BACKGROUND_REMOVED": "/media/maestroshield-whitelable/gallery/1789407680992-0.png",
  "GOLDEN_YELLOW_BLOB_SHAPE_GRAPHIC": "/media/maestroshield-whitelable/gallery/1789407134146-0.svg",
  "YELLOW_ORGANIC_BLOB_SHAPE": "/media/maestroshield-whitelable/gallery/1789407134146-1.png",
  "MAESTROSHIELD_RETRACTABLE_SCREEN_FABRIC_SAMPLES": "/media/maestroshield-whitelable/gallery/1789401398443-0.png",
  "SUNSET_OCEAN_VIEW_COVERED_PATIO_SECTIONAL_SOFA": "/media/maestroshield-whitelable/gallery/1789401398443-1.png",
  "MAKITA_DRILL_WINDOW_FRAME_METAL_INSTALLATION": "/media/maestroshield-whitelable/gallery/1789401398443-2.png",
  "WINDOW_FRAME_WIDTH_MEASUREMENT_TAPE": "/media/maestroshield-whitelable/gallery/1789401398443-3.png",
  "ROLLDOWN_SHUTTER": "/media/maestroshield-whitelable/gallery/1789398980630-0.png",
  "WINDOW_BLINDS_SHUTTERS_FEATURE_ICONS_SET": "/media/maestroshield-whitelable/gallery/1789389598551-0.png",
  "WIND_WEATHER_ICON_CIRCLE": "/media/maestroshield-whitelable/gallery/1789389598551-1.png",
  "SUN_ICON_NAVY_CIRCLE": "/media/maestroshield-whitelable/gallery/1789389598551-2.png",
  "SOLAR_PANEL_COLLECTOR_ICON": "/media/maestroshield-whitelable/gallery/1789389598551-3.png",
  "ROLLING_SHUTTER_DOOR_ICON": "/media/maestroshield-whitelable/gallery/1789389598551-4.png",
  "PRESENTATION_SCREEN_ICON_NAVY": "/media/maestroshield-whitelable/gallery/1789389598551-5.png",
  "BUG_INSECT_ICON_NAVY_CIRCLE": "/media/maestroshield-whitelable/gallery/1789389598551-6.png",
  "ADJUSTABLE_HEIGHT_TABLE_ICON": "/media/maestroshield-whitelable/gallery/1789389598551-7.png",
  "MAESTROSHIELD_RETRACTABLE_SCREENS_AD_PATIOS_BALCONIES_BACKGROUND_REMOVED": "/media/maestroshield-whitelable/gallery/1788955445395-0.png",
  "RETRACTABLE_SCREENS_MOBILE_APP_AD_0549764489": "/media/maestroshield-whitelable/gallery/1788954937970-0.png",
  "BLACK_WHITE_DIAGONAL_LIGHT_BEAM_ABSTRACT_MASK": "/media/maestroshield-whitelable/gallery/1788949657523-0.png",
  "OUTDOOR_PERGOLA_ENCLOSURE_WITH_ROLLER_BLINDS_DARK_FRAME": "/media/maestroshield-whitelable/gallery/1788901859998-0.webp",
  "WHITE_THREE_STORY_COASTAL_COMMERCIAL_BUILDING_EXTERIOR": "/media/maestroshield-whitelable/gallery/1788901803128-0.png",
  "MODERN_WHITE_SCREENED_PATIO_ENCLOSURE_EXTERIOR": "/media/maestroshield-whitelable/gallery/1788901803128-1.webp",
  "FLORIDA_WATERFRONT_MODERN_PERGOLA_WITH_LOUVERED_ROOF": "/media/maestroshield-whitelable/gallery/1788901374814-0.jpeg",
  "POOL_PATIO_MOTORIZED_SCREEN_SHADES_EXTERIOR": "/media/maestroshield-whitelable/gallery/1788901326476-0.webp",
  "ROOFTOP_BAR_PATIO_WOOD_CEILING_CEILING_FANS_BALCONY_VIEW": "/media/maestroshield-whitelable/gallery/1788901260340-0.webp",
  "RESTAURANT_PATIO_GREEN_RAILING_OUTDOOR_DINING_STREET_VIEW": "/media/maestroshield-whitelable/gallery/1788901260340-1.webp",
  "POOL_PATIO_MOTORIZED_SCREEN_SHADES_EXTERIOR_2": "/media/maestroshield-whitelable/gallery/1788901260340-2.webp",
  "SIROCCO_MEDITERRANEAN_RESTAURANT_OUTDOOR_PATIO_SCREENS": "/media/maestroshield-whitelable/gallery/1788901260340-3.webp",
  "AIRSTREAM_CARPORT_STONE_COLUMN_MOTORIZED_SCREENS": "/media/maestroshield-whitelable/gallery/1788901260340-4.webp",
  "2023_09_27_LAKEHOUSE_SCREEN_DOOR_OPENING_VIDEO": "/media/maestroshield-whitelable/gallery/1788884205543-0.mp4",
  "MAESTROSHIELD_BUILDING_EXTERIOR_SIGN": "/media/maestroshield-whitelable/gallery/1788883453710-0.jpg",
  "WATERFRONT_MODERN_HOME_POOL_PALM_TREES_FLORIDA": "/media/maestroshield-whitelable/gallery/1788883449472-0.png",
  "LUXURY_WATERFRONT_HOME_POOL_PALM_TREES_FLORIDA": "/media/maestroshield-whitelable/gallery/1788881930765-0.png",
  "MAESTRO_SHEIELD_LOGO": "/media/maestroshield-whitelable/gallery/1788881556813-0.png",
  "": ""
};

// Safe lookup — returns null when asset not yet uploaded (fresh clone).
// Pass null src to the Image component → shows skeleton placeholder.
export function getAsset(key) { return ASSETS[key] ?? null; }
